import { Controller } from "@hotwired/stimulus"

// The brief wizard's Intake options (channel processing spec 3.6, Brief wizard): Cloak Mode and
// Self Destruct reveal their bodies.
export default class extends Controller {
  static targets = ["cloakToggle", "cloakBody", "destructToggle", "destructBody"]

  connect() {
    this.render()
  }

  render() {
    const cloak = this.hasCloakToggleTarget && this.cloakToggleTarget.checked
    if (this.hasCloakBodyTarget) this.cloakBodyTarget.classList.toggle("hidden", !cloak)
    if (this.hasDestructBodyTarget) this.destructBodyTarget.classList.toggle("hidden", !(this.hasDestructToggleTarget && this.destructToggleTarget.checked))
  }
}
